import { useNavigate } from 'react-router-dom';

const T = {
  ink:    '#111',
  muted:  '#888',
  border: '#e5e5e5',
  font:   "'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif",
};

const IcoLock = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={T.ink} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2"/>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
);

const IcoCheck = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

/**
 * PaywallModal — shown when a user hits their plan limit.
 * Props:
 *   onClose()  — close the modal
 *   title      — headline (e.g. "Limit erreicht")
 *   message    — body text explaining the limit
 *   benefits   — string[] of upgrade bullet points (optional)
 */
export default function PaywallModal({ onClose, title, message, benefits }) {
  const navigate = useNavigate();

  const defaultBenefits = [
    'Bis zu 100 Einheiten verwalten',
    'Unbegrenzte Mieter',
    'Betriebskostenabrechnung',
    'Mieterportal',
    'Prioritäts-Support',
  ];
  const items = benefits || defaultBenefits;

  return (
    <div
      style={{
        position: 'fixed', inset: 0,
        background: 'rgba(0,0,0,0.48)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1200, padding: 24,
        fontFamily: T.font,
      }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{
        background: 'white',
        borderRadius: 20,
        width: '100%', maxWidth: 440,
        boxShadow: '0 24px 64px rgba(0,0,0,0.18)',
        overflow: 'hidden',
      }}>
        {/* Top accent bar */}
        <div style={{ height: 4, background: `linear-gradient(90deg, ${T.ink}, #555)` }} />

        <div style={{ padding: '32px 36px 28px' }}>
          {/* Icon */}
          <div style={{
            width: 52, height: 52, background: '#f5f5f5',
            border: `1px solid ${T.border}`, borderRadius: 13,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 20,
          }}>
            <IcoLock />
          </div>

          {/* Headline */}
          <h2 style={{ margin: '0 0 10px', fontSize: 20, fontWeight: 800, letterSpacing: '-0.5px', color: T.ink }}>
            {title || 'Plan-Limit erreicht'}
          </h2>
          <p style={{ margin: '0 0 24px', fontSize: 14, color: T.muted, lineHeight: 1.65 }}>
            {message || 'Du hast das Limit deines aktuellen Plans erreicht. Upgrade auf Professional, um weiterzumachen.'}
          </p>

          {/* Benefits */}
          <div style={{
            background: '#f5f5f5', border: `1px solid ${T.border}`,
            borderRadius: 12, padding: '16px 20px',
            marginBottom: 24,
          }}>
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.8px', textTransform: 'uppercase', color: T.ink, marginBottom: 12 }}>
              Professional enthält
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {items.map(b => (
                <div key={b} style={{ display: 'flex', alignItems: 'center', gap: 9, fontSize: 13, color: T.ink }}>
                  <span style={{ flexShrink: 0 }}><IcoCheck /></span>
                  {b}
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <button
            onClick={() => { onClose(); navigate('/plan-select'); }}
            style={{
              width: '100%', padding: '13px 0',
              background: T.ink, color: 'white', border: 'none',
              borderRadius: 10, fontSize: 14, fontWeight: 700,
              cursor: 'pointer', fontFamily: T.font,
              boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
              marginBottom: 10,
            }}
            onMouseEnter={e => e.currentTarget.style.background = '#000'}
            onMouseLeave={e => e.currentTarget.style.background = T.ink}
          >
            Jetzt upgraden →
          </button>
          <button
            onClick={onClose}
            style={{
              width: '100%', padding: '11px 0',
              background: 'transparent', color: T.muted,
              border: 'none', borderRadius: 10, fontSize: 13,
              cursor: 'pointer', fontFamily: T.font,
            }}
            onMouseEnter={e => e.currentTarget.style.color = T.ink}
            onMouseLeave={e => e.currentTarget.style.color = T.muted}
          >
            Vielleicht später
          </button>
        </div>
      </div>
    </div>
  );
}
